import { useTranslation } from '@invision/core';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { ConfirmationDialog } from '../../layout/ConfirmationDialog';

interface UnsavedChangesModalProps {
  callback: (arg0: boolean) => void;
}

function UnsavedChangesModal({ callback }: UnsavedChangesModalProps) {
  const { t } = useTranslation();
  return (
    <ConfirmationDialog
      type="warning"
      title={t('Unsaved Changes')}
      isOpen
      confirmButtonText={t('Leave Page')}
      cancelButtonText={t('Stay on Page')}
      close={() => {
        callback(false);
      }}
      onSubmit={() => {
        callback(true);
      }}
    >
      {t(
        'There are unsaved changes currently. You will lose these changes if you leave now. Are you sure you want to leave?'
      )}
    </ConfirmationDialog>
  );
}

/** Handler for [BrowserRouter.getUserConfirmation](https://reactrouter.com/web/api/BrowserRouter/getuserconfirmation-func) */
export function UserConfirmation(
  _message: string,
  callback: (arg0: boolean) => void
) {
  const container = document.createElement('div');
  const root = createRoot(container!);

  container.setAttribute('custom-confirmation-navigation', '');
  document.body.appendChild(container);

  const closeModal = (callbackState: boolean) => {
    root.unmount();
    document.body.removeChild(container);
    callback(callbackState);
  };

  root.render(<UnsavedChangesModal callback={closeModal} />);
}
